// extracted by mini-css-extract-plugin
export default {"error":"CreateQrTagBatch_error__kJUXU","successToast":"CreateQrTagBatch_successToast__Z5qhf","slideInRight":"CreateQrTagBatch_slideInRight__20aBZ"};